import React from 'react';
export class SocialMedia extends React.Component {
  constructor(props) {
    super(props);
  }
  handlePinterestClick = (event) => {
    window.open(
      `https://www.pinterest.com/pin/create/button/?url=www.dillards.com/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}&media=https://dimg.dillards.com/is/image/DillardsZoom/zoom/${this.props.contentData.productNameForURL}/${this.props.passedFunctions.parentState.selectedMainImg}.jpg&description=${encodeURIComponent(this.props.contentData.originalProductName)}%20%23Dillards`,
      'pininterest_share',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
    );
    event.preventDefault();
    return false;
  };
  buildTextHREF = () => {
    let textHREF =
      navigator.userAgent.match(/iPhone|iPad|iPod/i) && !navigator.userAgent.match(/iPhone OS 7|iPhone OS 8/i)
        ? 'sms:&'
        : 'sms:?';
    return textHREF;
  };

  render() {
    return (
      <ul className='social-icons'>
        <li className='share-email' onClick={this.props.passedFunctions.ajaxShareProductModal}>
          <span className='sr-only'>Opens a simulated dialog</span>
          <button type='button' className='btn-tertiary'>
            <svg xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='email' viewBox='0 0 48.49 32.94'>
              <title>email</title>
              <g data-name='Layer 2'>
                <g data-name='Layer 1'>
                  <polygon points='46.15 0 2.34 0 24.24 19.67 46.15 0' />
                  <path d='M48.14,1.71l-23,20.68a1.3,1.3,0,0,1-1.74,0L.35,1.71a1.26,1.26,0,0,1-.2-.27A2.22,2.22,0,0,0,0,2.24V30.7a2.24,2.24,0,0,0,2.24,2.24h44a2.24,2.24,0,0,0,2.24-2.24V2.24a2.22,2.22,0,0,0-.15-.79A1.26,1.26,0,0,1,48.14,1.71Z' />
                </g>
              </g>
            </svg>
          </button>
        </li>
        <li className='share-facebook'>
          <a
            href={`https://www.facebook.com/sharer.php?u=https%3a%2f%2fwww.dillards.com%2fp%2f${this.props.contentData.productNameForURL}%2f${this.props.contentData.productId}&t=Check+this+out+at+dillards.com`}
            target='_blank'
            rel='noreferrer'
          >
            <svg xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='facebook' viewBox='0 0 25.23 48.59'>
              <title>facebook</title>
              <g data-name='Layer 2'>
                <g data-name='Layer 1'>
                  <path d='M16.38,48.59V26.42h7.44l1.11-8.64H16.38V12.27c0-2.5.69-4.2,4.28-4.2h4.57V.34A61.3,61.3,0,0,0,18.57,0C12,0,7.46,4,7.46,11.42v6.37H0v8.64H7.46V48.59h8.92Z' />
                </g>
              </g>
            </svg>
          </a>
        </li>
        <li className='share-twitter'>
          <a
            href={`https://twitter.com/intent/tweet/?text=Check+this+out%3a&via=dillards&url=https%3a%2f%2fwww.dillards.com%2fp%2f${this.props.contentData.productNameForURL}%2f${this.props.contentData.productId}`}
            target='_blank'
            rel='noreferrer'
          >
            <svg xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='twitter' viewBox='0 0 24 24'>
              <title>Twitter/X</title>
              <g data-name='Layer 2'>
                <g data-name='Layer 1'>
                  <path d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'></path>
                </g>
              </g>
            </svg>
          </a>
        </li>
        <li className='share-pinterest'>
          <a
            href={`https://www.pinterest.com/pin/create/button/?url=www.dillards.com/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}&media=https://dimg.dillards.com/is/image/DillardsZoom/zoom/${this.props.contentData.productNameForURL}/${this.props.passedFunctions.parentState.selectedMainImg}.jpg&description=${encodeURIComponent(this.props.contentData.originalProductName)}%20%23Dillards`}
            target='_blank'
            onClick={this.handlePinterestClick}
            rel='noreferrer'
          >
            <svg xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='pinterest' viewBox='0 0 37.8 48.59'>
              <title>pinterest</title>
              <g data-name='Layer 2'>
                <g data-name='Layer 1'>
                  <path d='M16.47.16C8.4,1.06.35,7.6,0,16.93c-.21,5.7,1.41,10,6.83,11.17C9.2,23.95,6.09,23,5.61,20,3.62,7.72,19.8-.67,28.27,7.92c5.86,5.95,2,24.25-7.45,22.35C11.77,28.45,25.25,13.89,18,11c-5.87-2.32-9,7.11-6.21,11.8-1.63,8.06-5.15,15.65-3.72,25.76,4.62-3.35,6.17-9.76,7.45-16.45,2.32,1.41,3.56,2.87,6.52,3.1,10.92.84,17-10.9,15.52-21.73C36.26,3.91,26.67-1,16.47.16Z' />
                </g>
              </g>
            </svg>
          </a>
        </li>
        {this.props.siteFormat !== 'mobile' ? (
          <li className='share-print'>
            <button
              className='btn btn-tertiary'
              role='button'
              type='button'
              onClick={() => {
                window.print();
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='print' viewBox='0 0 46.42 48.59'>
                <title>print</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M32.61,42.16H22a1.42,1.42,0,0,1,0-2.83H32.61a1.42,1.42,0,1,1,0,2.83Z' />
                    <path d='M32.61,36.5H14.91a1.42,1.42,0,1,1,0-2.83h17.7a1.42,1.42,0,1,1,0,2.83Z' />
                    <path d='M43.49,13H38V0H8.42V13H2.92A2.92,2.92,0,0,0,0,15.88V32.45a2.92,2.92,0,0,0,2.92,2.92H8.42V48.59H38V35.38h5.49a2.92,2.92,0,0,0,2.92-2.92V15.88A2.92,2.92,0,0,0,43.49,13ZM35.17,35.38V45.84H11.25V29.69H35.17Zm0-22.43H11.25V2.83H35.17Zm7.35,5.79a1.24,1.24,0,1,1,1.24-1.24A1.24,1.24,0,0,1,42.52,18.74Z' />
                  </g>
                </g>
              </svg>
            </button>
          </li>
        ) : (
          ''
        )}
        {this.props.siteFormat == 'mobile' ? (
          <li className='share-text'>
            <a
              href={`${this.buildTextHREF()}body=https://www.dillards.com/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}`}
            >
              <svg xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='mobile' viewBox='0 0 32.66 49.22'>
                <title>mobile</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M26.91,0H5.76A5.76,5.76,0,0,0,0,5.76v37.7a5.76,5.76,0,0,0,5.76,5.76H26.91a5.76,5.76,0,0,0,5.76-5.76V5.76A5.76,5.76,0,0,0,26.91,0Zm-17,3.42H22.78a.62.62,0,0,1,0,1.25H9.88a.62.62,0,0,1,0-1.25ZM16.33,47A1.67,1.67,0,1,1,18,45.37,1.67,1.67,0,0,1,16.33,47Zm12.94-5.56H3.39V7.74H29.27Z' />
                  </g>
                </g>
              </svg>
            </a>
          </li>
        ) : (
          ''
        )}
      </ul>
    );
  }
}

export default SocialMedia;
